
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refer/[code]",
      function () {
        return require("private-next-pages/refer/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refer/[code]"])
      });
    }
  